import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Case } from '../../../../../../../../../_base-shared/models/Case/Case';
import { CaseCreditorStatusChange } from '../../../../../../../../../_base-shared/models/Case/CaseCreditorStatusChange';
import { MainBaseApiService } from '../../../../../../_shared/services/main-base-api.service';
import { CaseCreditorService } from '../../../../case-creditor.service';


@Component({
  standalone: false,
  selector:    'app-case-creditor-status-log',
  templateUrl: './case-creditor-status-log.component.html',
  styles:      []
})
export class CaseCreditorStatusLogComponent implements OnInit, OnDestroy {
  @Input() caseCreditorId: number;
  @Input() case: Case;
  public isLoading                                               = 0;
  public caseCreditorStatusLogs: Array<CaseCreditorStatusChange> = [];
  private subscriptions: Array<Subscription>                     = [];

  constructor(private caseCreditorService: CaseCreditorService) {
  }

  ngOnInit(): void {
    this.fetchLogs(this.case.id);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  private fetchLogs(caseId: number): void {
    const relations = ['case_creditor', 'to_status', 'from_status', 'user'];
    const data = {select_all: 1};
    const requestData = MainBaseApiService.convertFiltersForRequest(
      { ...data, with: relations }, 'get'
    );

    const observable = this.caseCreditorId  ?
      this.caseCreditorService.indexStatusChanges(caseId, this.caseCreditorId, requestData) :
      this.caseCreditorService.getCaseCreditorStatusLogs(caseId, requestData );


    this.isLoading++;
    this.subscriptions.push(
        observable
        .pipe(finalize(() => this.isLoading--)).subscribe(
        result => {
          this.caseCreditorStatusLogs = result.data;
        },
      ),
    );
  }
}
